export default __webpack_public_path__ + "static/media/HSU_Logo.b3befc49.svg";